app-observation-config-works!
